import React from "react";
import {
  Area,
  AreaChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
} from "recharts";
import { sortByMonthAndYearRips } from "../../util/sortCart";

function ChartRips({ manager, text }) {
  //console.log(manager);
  let monthlyData = [];
  if (manager.length !== 0) monthlyData = sortByMonthAndYearRips(manager);
  return (
    <div className="">
      <div>
        {/* <div className="text-[#9E9E9E]  py-2 px-6">{text}</div> */}
        <div className="  w-[97%] h-[300px] m-auto mt-[20px]">
          <ResponsiveContainer>
            <AreaChart
              // width={950}
              // height={height}
              data={monthlyData}
              // margin={{ top: 15 }}
            >
              <defs>
                <linearGradient id="ripsIn" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#739D00" stopOpacity={0.9} />
                  <stop offset="95%" stopColor="#739D00" stopOpacity={0} />
                </linearGradient>
                <linearGradient id="ripsIra" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#e91e63" stopOpacity={0.6} />
                  <stop offset="95%" stopColor="#e91e63" stopOpacity={0} />
                </linearGradient>
                <linearGradient id="ripsNati" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#8e24aa" stopOpacity={0.6} />
                  <stop offset="95%" stopColor="#8e24aa" stopOpacity={0} />
                </linearGradient>
                <linearGradient id="ripsRuti" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="5%" stopColor="#ff5722" stopOpacity={0.6} />
                  <stop offset="95%" stopColor="#ff5722" stopOpacity={0} />
                </linearGradient>
              </defs>
              <XAxis dataKey="name" stroke="gray" />
              <CartesianGrid
                strokeDasharray="3 3"
                className="stroke-[#9c9a9a]"
              />
              <Tooltip />
              <Legend />
              <Area
                type="monotone"
                dataKey="IN"
                stroke="#739D00"
                fillOpacity={1}
                fill="url(#ripsIn)"
              />
              <Area
                type="monotone"
                dataKey="Ira"
                stroke="#e91e63"
                fillOpacity={1}
                fill="url(#ripsIra)"
              />
              <Area
                type="monotone"
                dataKey="Nati"
                stroke="#8e24aa"
                fillOpacity={1}
                fill="url(#ripsNati)"
              />
              <Area
                type="monotone"
                dataKey="Ruti"
                stroke="#ff5722"
                fillOpacity={1}
                fill="url(#ripsRuti)"
              />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
}

export default ChartRips;
